export default "__VITE_ASSET__B05MgTTR__"